<template src="./TimeZonePicker.template.html" />
<style scoped src="./TimeZonePicker.style.css" />

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
    name: "TimeZonePicker",

    data: () => ({
        showMenu: false,

        timeZone: "local",
        is24Hour: false,
        isShowSeconds: false,

        timeZones: [
            { value: "local", text: "Device Timezone" },
            { value: "utc", text: "UTC" },
            { value: "us/eastern", text: "US/Eastern" },
            { value: "us/central", text: "US/Central" },
            { value: "us/mountain", text: "US/Mountain" },
            { value: "us/pacific", text: "US/Pacific" },
            { value: "us/arizona", text: "US/Arizona" },
            { value: "us/alaska", text: "US/Alaska" },
            { value: "us/hawaii", text: "US/Hawaii" },
        ],
    }),

    computed: {
        ...mapGetters("settings", ["settings"]),
        selectedTimeZone: {
            get() {
                return this.timeZones.find((x) => x.value == this.settings?.location)?.text;
            },
            set() {}, // eat the setter
        },
    },

    mounted() {
        this.loadSettings();
    },

    watch: {
        showMenu() {
            this.loadSettings();
        },
    },

    methods: {
        ...mapMutations("settings", ["setTimeZone", "setTimeFormat24Hour", "setTimeFormatShowSeconds"]),

        loadSettings() {
            this.timeZone = this.settings?.location;
            this.is24Hour = this.settings?.timeFormat24Hour;
            this.isShowSeconds = this.settings?.timeFormatShowSeconds;
        },

        saveSettings() {
            this.setTimeZone(this.timeZone);
            this.setTimeFormat24Hour(this.is24Hour);
            this.setTimeFormatShowSeconds(this.isShowSeconds);

            this.showMenu = false;
        },
    },
};
</script>
